module.exports = __webpack_public_path__ + "img/serv_sub3_2.804d1718.jpg";